import React from 'react';
import styled from 'styled-components';
import { ImageDivView, ImageWrapperDiv } from '../styles/ImageWrapper'
import placeholder_image from '../assests/placeholder_image.png'
import chrome_icon from '../assests/chrome_icon.png';



const ChromeImageParent = styled.img`
  width: 25px;
  height: 25px;
  margin-left: -40px;
    margin-top: 14px;
  border-radius: 35px;
  position: absolute;
  cursor: pointer;
  visibility: hidden;
  ${ImageWrapperDiv}:hover & {
    visibility: visible;
  }
`;

const openGoogleImages = (imageUrl) => {
  navigator.clipboard.writeText(imageUrl);
  const lensUrl = `https://images.google.com/`;
  window.open(lensUrl, '_blank');
};


export default function ImageDiv(props) {
  return (
    <ImageWrapperDiv
      rectangle={false}
      height={props.height}
      is_small={props.is_small}
      is_end={props.is_end}
    >
      <ImageDivView
        rectangle={props.rectangle}
        height={props.height}
        is_small={props.is_small}
        onClick={() => {
          if (props.can_click) props.imageClicked();
        }}
        src={props.src}
        is_end={true}
        onError={e => {
          e.target.src = placeholder_image;
        }}
      />
      <ChromeImageParent
        onClick={(event) => openGoogleImages(props.src)}
        src={chrome_icon}
      />
    </ImageWrapperDiv >
  );
}
